import React from 'react';
import { IMAGE_BASE } from '../constants/site';
import { TEAM_HIGHLIGHTS } from '../Solutions/solutionsData';

const OurTeam = () => (
  <section className="about-team" aria-label="Our Team">
    <h2 className="about-team__title">Our Team</h2>

    <div className="about-team__hero">
      <img src={`${IMAGE_BASE}/img36.jpg`} alt="Vientiane Traffic team" />
      <div className="about-team__hero-overlay" />
      <div className="about-team__hero-content">
        <p className="about-team__hero-text">
          Dedicated professionals ensuring safety, excellence, and innovation in every project.
        </p>
        <span className="about-team__hero-label">Vientiane Traffic Team</span>
      </div>
    </div>

    <div className="about-team__grid">
      {TEAM_HIGHLIGHTS.map((item) => (
        <article key={item.title} className="about-team__card">
          <div className="about-team__card-media">
            <img src={item.image} alt={item.title} />
          </div>
          <h3>{item.title}</h3>
        </article>
      ))}
    </div>
  </section>
);

export default OurTeam;
